import React from 'react';
import { Link } from "react-router-dom";
import * as URL from '../../router/url';
import classNames from 'classnames';
import Logo from '../../assets/img/rgs_logo.png';
import { useLocation } from "react-router-dom";

function HeaderBottom() {
    const location = useLocation();

    const handleClick = () => {
        window.scrollTo(0,0);
    }

    const { pathname } = location;

    return (
        <section>
            <header
                className={
                    classNames(
                        'header-desktop-bottom',
                        { '-home': pathname === URL.ROOT }
                    )
                }
            >
                <div 
                    className={
                        classNames(
                            'company_logo hide-xs show-lg',
                            { '-home': pathname === URL.ROOT }
                        )
                    }
                >
                    <Link
                        className="company_logo--inner"
                        to={URL.ROOT}
                        onClick={handleClick}
                    >
                        <figure className="image is-64x64">
                            <img src={Logo} alt="company logo" />
                        </figure>
                        <span className="is-family-secondary">РГ-АСУ-НАЛАДКА</span>
                    </Link>
                </div>
                <nav 
                    className={
                        classNames(
                            'header-desktop-nav', 
                            { commissioning_works: pathname === URL.COMMISSIONING_WORKS }, 
                            { automation: pathname === URL.AUTOMATION }
                        )
                    }
                >
                    <div 
                        className="large_section"
                        to={URL.COMMISSIONING_WORKS} 
                        onClick={handleClick}
                    >
                        <Link
                            className={
                                classNames(
                                    'large_section__item commissioning_works',
                                    { active: pathname === URL.COMMISSIONING_WORKS },
                                )
                            }
                            to={URL.COMMISSIONING_WORKS}
                            onClick={handleClick}
                        >
                            <div className="is-family-secondary">Пусконаладочные работы</div>
                        </Link>
                        <Link
                            className={
                                classNames(
                                    'large_section__item automation',
                                    { active: pathname === URL.AUTOMATION },
                                )
                            }
                            to={URL.AUTOMATION}
                            onClick={handleClick}
                        >
                            <div className="is-family-secondary">Автоматизация</div>
                        </Link>
                    </div>
                    <Link to={URL.ABOUT} onClick={handleClick}>   
                        <div
                            className={
                                classNames(
                                    'header-desktop-nav-item',
                                    { current: pathname === URL.ABOUT }
                                )
                            }
                        >
                            О компании
                        </div>
                    </Link>
                    <Link to={URL.PROJECTS} onClick={handleClick}>   
                        <div
                            className={
                                classNames(
                                    'header-desktop-nav-item',
                                    { current: pathname?.split('/')[1] === URL.PROJECTS.split('/')[1] }
                                )
                            }
                        >
                            Проекты
                        </div>
                    </Link>
                    <Link to={URL.VACANCIES} onClick={handleClick}>   
                        <div 
                            className={
                                classNames(
                                    'header-desktop-nav-item',
                                    { current: pathname?.split('/')[1] === URL.VACANCIES.split('/')[1] }
                                )
                            }
                        >
                            Вакансии
                        </div>
                    </Link>
                    <Link to={URL.CONTACTS} onClick={handleClick}>   
                        <div 
                            className={
                                classNames(
                                    'header-desktop-nav-item',
                                    { current: pathname === URL.CONTACTS }
                                )
                            }
                        >
                            Контакты
                        </div>
                    </Link>
                </nav>
            </header>   
        </section>     
    )
}

export default HeaderBottom;